// extracted by mini-css-extract-plugin
module.exports = {"placeholderAnimation":"Animation_placeholderAnimation__F1tid","place-holder-shimmer":"Animation_place-holder-shimmer__CBt_J"};